<template>
    <div>
        <table width="100%">
            <tr>
                <td width="40%"><strong>Projectnaam</strong></td>
                <td>{{ project.name }}</td>
            </tr>
            <tr>
                <td width="40%"><strong>Status</strong></td>
                <td>{{ project.status | formatStatus }}</td>
            </tr>
            <tr>
                <td width="40%"><strong>Opdrachtgever</strong></td>
                <td>{{ project.company.name }}</td>
            </tr>
            <tr>
                <td><strong>Dossiernummer</strong></td>
                <td>{{ project.file_id }}</td>
            </tr>
            <tr>
                <td><strong>Start datum</strong></td>
                <td>{{ project.startDate | format }}</td>
            </tr>
            <tr>
                <td valign="top"><strong>Werkzaamheden</strong></td>
                <td>{{ project.activities.join(', ') }}</td>
            </tr>
        </table>

        <div class="description" v-if="project.description" v-html="project.description"></div>
    </div>
</template>

<script>
	import moment from 'moment'

	export default {
		props: [ 'project' ],

		filters: {
			format (value) {
				moment.locale('nl')
				return moment(value).format('LL')
			},

			formatStatus( value ) {
				if( value === 1 ) return 'Afgerond/gesloten';

				return 'Actief'
            }
		},
    }
</script>